function handleNewsSlider(e) {
  const direction = e.target.dataset.dir
  const slider = e.target.parentElement.querySelector('.gdc-news-list__slider')

  slider.scrollBy({
    top: 0,
    left: direction === 'prev' ? -window.innerWidth + 60 : window.innerWidth - 60,
    behavior: 'smooth',
  })
}
